import { usePage } from '@inertiajs/react'
import CartierLensCreditsBanner from '@/Components/CartierLensCreditsBanner'
import HouseOfPradaLensCreditsBanner from '@/Components/HouseOfPradaLensCreditsBanner'
import { maxLensCredit } from '@/Util/LensCredit'

// The strip for the lens credit group picked to front the site
// (settings.promotions.lensCreditEvent.banner, set in the admin's Lens Credit Events)
export default ({ group, className = '' }) => {
    const { props } = usePage()
    const upTo = maxLensCredit(props.settings?.promotions?.lensCreditEvent, group) || undefined

    if (group === 'cartier') {
        return <CartierLensCreditsBanner href="/glasses/cartier-eyewear" className={className} upTo={upTo} />
    }

    if (group === 'house_of_prada') {
        return <HouseOfPradaLensCreditsBanner href="/newest/luxury-lens-credits" className={className} upTo={upTo} />
    }

    return null
}
